// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sharedClassName } from "@eisinc/App/Components/ProductGridCard/ProductGridContainer";
import { sharedCarouselStyles } from "@eisinc/App/SharedStyles/ProductCarouselStyles";
import { productCompareFlyOutStyles } from "@eisinc/Overrides/Components/ProductCompareFlyOut";
import { color, xScreen } from "@eisinc/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import { css } from "styled-components";

productCompareFlyOutStyles.carouselDrawer = {
    position: "bottom",
    cssOverrides: {
        scrim: css`
            height: auto;
            max-height: 240px;
            ${xScreen("lte", "sm")} {
                height: 60px;
            }
            ${xScreen("lte", "xs")} {
                height: 105px;
            }
        `,
        drawerBody: css`
            height: auto;
            max-height: 240px;
            ${xScreen("lte", "sm")} {
                height: 60px;
            }
            ${xScreen("lte", "xs")} {
                height: 105px;
            }
        `,
        drawerContent: css`
            height: 168px;
            ${xScreen("lte", "sm")} {
                display: none;
            }
        `,
        drawerTitle: css`
            background: ${getColor("common.accent")};
            color: ${getContrastColor("common.accent")};
            padding-left: 5px;
            padding-right: 5px;
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

productCompareFlyOutStyles.carouselDrawerContainer = {
    css: css`
        .carousel-products-container {
            padding-left: 0;
            padding-right: 0;
            padding-bottom: 0;

            .swiper-container {
                padding-left: 0;
                padding-right: 0;
                margin-left: 25px;
                margin-right: 25px;
                width: calc(100% - 50px);
            }

            .swiper-slide {
                padding: 2px;
                width: 330px;
                > div {
                    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
                    border: 2px solid transparent;
                    &:hover,
                    &:focus {
                        border: 2px solid ${getColor("common.ui3")};
                        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
                    }
                }
            }
        }
        ${xScreen("lte", "sm")`display: none;`}
    `,
};

productCompareFlyOutStyles.headerTitleText = {
    variant: "h4",
    forwardAs: "p",
};

productCompareFlyOutStyles.headerGridContainer = {
    gap: 0,
    css: css`
        margin: 0;
    `,
};

productCompareFlyOutStyles.carouselCardStyles = {
    ...sharedCarouselStyles.miniCardStyles,
    productGridContainerStyles: {
        ...sharedCarouselStyles.miniCardStyles?.productGridContainerStyles,
        container: {
            css: css`
                ${sharedCarouselStyles.miniCardStyles?.productGridContainerStyles?.container?.css}
                grid-template-rows:  minmax(0, 1fr);
                padding: 16px;
                background: ${color("common.white")};
                &&&& {
                    max-width: 324px;
                }
                & > .bottom-section {
                    display: none;
                }
                & > .middle-section {
                    .${sharedClassName}-imageBadges {
                        display: none;
                    }
                }
            `,
        },
    },
};
